export enum PaymentStateEnum {
  CONCEPT = 'CONCEPT',
  PENDING = 'PENDING',
  PAID = 'PAID',
}
